import { render } from "./ConfirmationView.vue?vue&type=template&id=024bb05d&scoped=true"
import script from "./ConfirmationView.vue?vue&type=script&lang=js"
export * from "./ConfirmationView.vue?vue&type=script&lang=js"

import "./ConfirmationView.vue?vue&type=style&index=0&id=024bb05d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024bb05d"]])

export default __exports__